import React, { Component } from 'react';
import { authContext } from '../adalConfig';
import axios from 'axios';
import './react-datetime.css';
import 'react-table/react-table.css';
import Dropdown from 'react-dropdown';
import 'react-dropdown/style.css';
import './MonthlyView.css';
import { CSVLink } from "react-csv";
import { sanitizeCsvData } from './csvSanitizer';
import ReactTable from "react-table";
import 'react-table/react-table.css';
import Modal from 'react-modal';
import * as appsettings from './constants';
import ReactDOM from 'react-dom';
import DateTime from 'react-datetime';
import './react-datetime.css';
import './Modal.css';
import TelemetryDetailModal from './TelemetryDetailModal';

// Computes the severity ('green' | 'orange' | 'red' | null) of a metric value
// for the currently-selected metric type, mirroring the ARP cell coloring logic.
function getMetricSeverity(metricType, value) {
    const v = Number(value);
    if (!v || v <= 0) {
        return null;
    }
    if (metricType === 'Availability') {
        if (v >= appsettings.AvailabilityLegacyGreenTarget) return 'green';
        if (v >= appsettings.AvailabilityOrangeTarget) return 'orange';
        return 'red';
    }
    if (metricType === 'Reliability') {
        if (v >= appsettings.ReliabilityGreenTarget) return 'green';
        if (v >= appsettings.ReliabilityOrangeTarget) return 'orange';
        return 'red';
    }
    if (metricType === 'Performance') {
        if (v >= appsettings.PerformanceGreenTarget) return 'green';
        if (v >= appsettings.PerformanceOrangeTarget) return 'orange';
        return 'red';
    }
    return null;
}
const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        height: '450px',
        width: '500px',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};
export class MonthlyView extends Component {
    displayName = MonthlyView.name
    constructor(props) {
        super(props);
        this.today = new Date();
        this.exceptionDate = new Date();
        this.exceptionDate.setUTCFullYear(1950);
        this.today.setDate(this.today.getDate() - 2);
        this.today.setHours(5);
        this.today.setMinutes(30);
        this.today.setSeconds(0);
        this.tomorrow = new Date();
        this.tomorrow.setDate(this.tomorrow.getDate());
        this.tomorrow.setHours(5);
        this.tomorrow.setMinutes(30);
        this.tomorrow.setSeconds(0);
        this.state = {
            TempData: [], datatobeshown: appsettings.datatobeshown[0],
            month: 0, year: 0,
            greenFont: appsettings.ReliabilityOrangeTarget,
            Columns: [], Metric: [],
            metricType: appsettings.metricTypes[0],
            environment: appsettings.options[0],
            loading: false, modalIsOpen: false, userId: '',
            DSMService: '', Service: '', ComponentName: '',
            SelectedMonthandYear: '',
            selectedRow: '', selectedColumn: '',
            detailModalOpen: false, detailLoading: false, detailError: false, detailData: [],
            detailSeverity: 'orange', detailAppname: '', detailComponent: '', detailService: '', detailDSMService: '',
            detailMetricType: '', detailMetricValue: '', detailTimeRange: '',
            fromDate: this.today.toISOString(), toDate: this.tomorrow.toISOString(),
            exceptionDate: this.exceptionDate.toISOString()
        };
        this.openModal = this.openModal.bind(this);
        this.afterOpenModal = this.afterOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onMetricCellClick = this.onMetricCellClick.bind(this);
        this.closeDetailModal = this.closeDetailModal.bind(this);
    }
    // Formats the selected month (UTC) as e.g. "August 2026 UTC".
    formatMonthRange(startIso) {
        if (!startIso) { return ''; }
        return new Date(startIso).toLocaleDateString('en-US', { year: 'numeric', month: 'long', timeZone: 'UTC' }) + ' UTC';
    }
    // Collapses duplicate URLs into one row with summed failures, sorted desc.
    aggregateByUrl(records) {
        const map = new Map();
        for (let i = 0; i < records.length; i++) {
            const r = records[i];
            const rawUrl = (r.Url || '').trim();
            if (!rawUrl) { continue; }
            const normalizedUrl = rawUrl.replace(/\/+$/, '').toLowerCase();
            const method = (r.HttpMethod || 'UNKNOWN').trim().toUpperCase();
            const key = `${normalizedUrl}::${method}`;
            const count = Number(r.FailureCount) || 0;
            if (map.has(key)) {
                map.get(key).FailureCount += count;
            } else {
                map.set(key, Object.assign({}, r, {
                    Url: rawUrl,
                    HttpMethod: method === 'UNKNOWN' ? '' : method,
                    FailureCount: count
                }));
            }
        }
        return Array.from(map.values()).sort((a, b) => b.FailureCount - a.FailureCount);
    }
    componentDidMount() {
        this.getLatestMonth();
        this.getData(this.state.metricType.value, this.state.environment.value);
        var user = authContext.getCachedUser();
        var userId = user.userName;
        var domainIndex = userId.indexOf('@microsoft.com');
        userId = userId.substr(0, domainIndex);
        this.setState({
            userId: userId
        })
    }
    openModal(row, col) {
        if (col !== -2) {
            this.setState({ modalIsOpen: true });
        }

    }
    closeModal() {
        this.setState({ modalIsOpen: false })
    }
    onMetricCellClick(rowData, accessor, severity) {
        const metricType = this.state.metricType.value;
        const appname = rowData.appname || rowData.Component || '';
        // Scope the URL-failure details to the month represented by the clicked
        // column. Column->month mapping mirrors the render logic below
        // (dataN -> selectedMonths[6-N], month index = state.month - j - 1).
        const n = parseInt(String(accessor).replace('data', ''), 10);
        let startDate = null, endDate = null;
        if (!isNaN(n) && this.state.month && this.state.year) {
            const j = 6 - n;
            let month0 = this.state.month - j - 1;
            let y = this.state.year;
            if (month0 < 0) { month0 = (month0 + 12) % 12; y = y - 1; }
            startDate = new Date(Date.UTC(y, month0, 1)).toISOString();
            endDate = new Date(Date.UTC(y, month0 + 1, 1)).toISOString();
        }
        this.setState({
            detailModalOpen: true,
            detailLoading: true,
            detailError: false,
            detailData: [],
            detailSeverity: severity,
            detailAppname: appname,
            detailComponent: rowData.Component || '',
            detailService: rowData.Service || '',
            detailDSMService: rowData.DSMService || '',
            detailMetricType: metricType,
            detailMetricValue: rowData[accessor]
        });
        this.setState({ detailTimeRange: this.formatMonthRange(startDate) });
        this.fetchUrlFailureDetails(appname, this.state.environment.value, metricType, startDate, endDate);
    }
    fetchUrlFailureDetails(appname, environment, metricType, startDate, endDate) {
        const token = authContext.getCachedToken(authContext.config.clientId);
        var apilink = "api/CosmosApi/GetUrlFailureDetails/?appname=" + encodeURIComponent(appname)
            + "&environment=" + encodeURIComponent(environment)
            + "&metricType=" + encodeURIComponent(metricType);
        if (startDate && endDate) {
            apilink += "&startDate=" + encodeURIComponent(startDate) + "&endDate=" + encodeURIComponent(endDate);
        }
        axios.get(apilink, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        }).then(response => {
            var data = response.data;
            if (typeof data === 'string') {
                try { data = JSON.parse(data); } catch (e) { data = []; }
            }
            if (!Array.isArray(data)) { data = []; }
            this.setState({
                detailLoading: false,
                detailError: false,
                detailData: this.aggregateByUrl(data)
            });
        }).catch(err => {
            console.error('GetUrlFailureDetails failed', err);
            this.setState({
                detailLoading: false,
                detailError: true,
                detailData: []
            });
        });
    }
    closeDetailModal() {
        this.setState({ detailModalOpen: false });
    }
    afterOpenModal() {
        this.subtitle.style.color = '#f00';
    }

    getData(metric, environment) {
        this.setState({
            loading: true
        });
        const token = authContext.getCachedToken(authContext.config.clientId);
        var apilink =  "api/CosmosApi/GetMonthly/?metricType=" + metric + "&environment=" + environment;
        axios.get(apilink,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            this.setState({
                loading: false,
                Metric: response.data,
                TempData: response.data
            });
        });

    }
    onSelectDataToBeShown(event) {
        if (event.value === 'All') {
            this.setState({
                Metric: this.state.TempData
            })
        }
        else {
            var datatobedisplayed = [];
            for (var i = 0; i < this.state.Metric.length; i++) {
                if (
                    (this.state.Metric[i].data1 < this.state.greenFont && this.state.Metric[i].data1 > 0) ||
                    (this.state.Metric[i].data2 < this.state.greenFont && this.state.Metric[i].data2 > 0) ||
                    (this.state.Metric[i].data3 < this.state.greenFont && this.state.Metric[i].data3 > 0) ||
                    (this.state.Metric[i].data4 < this.state.greenFont && this.state.Metric[i].data4 > 0) ||
                    (this.state.Metric[i].data5 < this.state.greenFont && this.state.Metric[i].data5 > 0) ||
                    (this.state.Metric[i].data6 < this.state.greenFont && this.state.Metric[i].data6 > 0)
                )
                    datatobedisplayed.push(this.state.Metric[i]);
            }
            this.setState({
                Metric: datatobedisplayed
            })
        }
    }
    getLatestMonth() {

        var apilink = "api/CosmosApi/GetLatestMonth/";
        const token = authContext.getCachedToken(authContext.config.clientId);
        axios.get(apilink,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
            this.setState({
                month: response.data[0],
                year: response.data[1]
            });
        });

    }
    updateFromDate(date) {
        try {
            this.setState({
                fromDate: date._d.toISOString()
            });
        }
        catch (err) {
            this.setState({
                fromDate: this.state.exceptionDate,
                toDate: this.state.exceptionDate
            });

        }
    }
    updateToDate(date) {
        try {
            this.setState({
                toDate: date._d.toISOString()
            });
        }
        catch (err) {
            this.setState({
                fromDate: this.state.exceptionDate,
                toDate: this.state.exceptionDate
            });
        }
    }
    onSelectEnvironment(event) {
        this.setState({
            environment: event
        });
        this.getData(this.state.metricType.value, event.value);
    }
    onSelectmetricType(event) {
        this.setState({
            metricType: event
        });
        this.getData(event.value, this.state.environment.value);

        if (event.value === "Performance") {
            this.setState({
                greenFont: appsettings.PerformanceGreenTarget
            });
        }
        else if (event.value === "Availability") {
            this.setState({
                greenFont: appsettings.AvailabilityGreenTarget
            });
        }
        else {
            this.setState({
                greenFont: appsettings.ReliabilityGreenTarget
            });
        }
    }
    submitComment() {
        var comment = ReactDOM.findDOMNode(this.refs.InputComment).value;
        const token = authContext.getCachedToken(authContext.config.clientId);
        var apilink =  "api/CosmosApi/GetAddComment/?portalName="
            + this.state.ComponentName + "&metricType=" + this.state.metricType.label + "&fromDate=" + this.state.fromDate + "&toDate=" + this.state.toDate + "&alias=" + this.state.userId + "&comment=" + comment;
        axios.post(apilink, null,
            {
                headers: {
                    Authorization: `Bearer ${token}` // This correctly adds the token as a Bearer token
                }
            }).then(response => {
        });
        alert('Comment added successfully');
        this.closeModal();
    }
    openHelp() {
        const url = appsettings.HelpPageRootURL;
        const w = window.open(url, '_blank', 'noopener,noreferrer');
        if (w != null) {
            w.opener = null;
        } else {
            window.location.href = url;
        }
    }
    render() {
        var Months = appsettings.Months;
        var selectedMonths = ['', '', '', '', '', ''];
        for (var j = 0; j < 6; j++) {
            var month = this.state.month - j - 1;
            var year = this.state.year;
            if (month < 0) {
                month = (month + 12) % 12;
                year = year - 1;
            }
            selectedMonths[j] = Months[month] + " " + year;
        }
        var columns = [
            { Header: appsettings.DSMService, accessor: 'DSMService', filterMethod: (filter, row) => { var rowdata = row[filter.id].toLowerCase(); var input = filter.value.toLowerCase(); return rowdata.includes(input); }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'left' } } } },
            { Header: appsettings.Service, accessor: 'Service', filterMethod: (filter, row) => { var rowdata = row[filter.id].toLowerCase(); var input = filter.value.toLowerCase(); return rowdata.includes(input); }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'left' } } } },
            { Header: appsettings.ComponentHeader, accessor: 'Component', filterMethod: (filter, row) => { var rowdata = row[filter.id].toLowerCase(); var input = filter.value.toLowerCase(); return rowdata.includes(input); }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'left' } } } },
            { Header: selectedMonths[0], accessor: 'data6', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'right', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data6 >= this.state.greenFont ? "green" : rowInfo.row.data6 > 0 ? "red" : "white" } }; }, width: 80 },
            { Header: selectedMonths[1], accessor: 'data5', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'right', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data5 >= this.state.greenFont ? "green" : rowInfo.row.data5 > 0 ? "red" : "white" } }; }, width: 80 },
            { Header: selectedMonths[2], accessor: 'data4', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'right', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data4 >= this.state.greenFont ? "green" : rowInfo.row.data4 > 0 ? "red" : "white" } }; }, width: 80 },
            { Header: selectedMonths[3], accessor: 'data3', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'right', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data3 >= this.state.greenFont ? "green" : rowInfo.row.data3 > 0 ? "red" : "white" } }; }, width: 80 },
            { Header: selectedMonths[4], accessor: 'data2', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'right', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data2 >= this.state.greenFont ? "green" : rowInfo.row.data2 > 0 ? "red" : "white" } }; }, width: 80 },
            { Header: selectedMonths[5], accessor: 'data1', filterMethod: (filter, row) => { return row[filter.id] <= filter.value && row[filter.id] > 0 }, getProps: (state, rowInfo, column) => { return { style: { textAlign: 'right', fontSize: '17px', fontWeight: 'bold', color: rowInfo.row.data1 >= this.state.greenFont ? "green" : rowInfo.row.data1 > 0 ? "red" : "white" } }; }, width: 80 },
        ];

        var csvHeaders = [
            { label: appsettings.DSMService, key: 'DSMService' },
            { label: appsettings.Service, key: 'Service' },
            { label: appsettings.ComponentHeader, key: 'Component' },
            { label: selectedMonths[0], key: 'data6' },
            { label: selectedMonths[1], key: 'data5' },
            { label: selectedMonths[2], key: 'data4' },
            { label: selectedMonths[3], key: 'data3' },
            { label: selectedMonths[4], key: 'data2' },
            { label: selectedMonths[5], key: 'data1' }
        ]
        return (
            <div>
                <div id="banner">
                    <h4 id="header">{appsettings.MonthlyViewHeader}</h4>
                </div>
                <div style={{ height: '8%', width: '100%', display: 'inline-flex', marginTop: '-3%' }}>
                    <div id='EnvTitle'>Environment:</div>
                    <Dropdown className='Environment' options={appsettings.options} onChange={this.onSelectEnvironment.bind(this)} value={this.state.environment} placeholder="Select an option" />
                    <div id='starttime'>Metric Type:</div>
                    <Dropdown className='metricType' options={appsettings.metricTypes} onChange={this.onSelectmetricType.bind(this)} value={this.state.metricType} placeholder="Select an option" />
                    <div id='EnvTitle' style={{ marginLeft: '10px' }}>Display:</div>
                    <Dropdown className='datatobedisplayed' options={appsettings.datatobeshown} onChange={this.onSelectDataToBeShown.bind(this)} value={this.state.datatobeshown} placeholder="Select an option" />
                    <CSVLink data={sanitizeCsvData(this.state.Metric)} filename={"CSTelemetry.csv"} headers={csvHeaders} className="csvExport">Export to csv</CSVLink>
                    {/* Changed: use anchor to always open in a new tab */}
                    <a
                        id='HelpButton'
                        href={appsettings.HelpPageRootURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        title="ECTelemetry Wiki"
                        aria-label="ECTelemetry Wiki"
                        style={{ marginLeft: '10px' }}
                    >
                        ECTelemetry Wiki
                    </a>
                </div>
                <hr />

                <p id='target'>Target : Availability: &gt;={appsettings.AvailabilityGreenTarget}%, Reliability: &gt;={appsettings.ReliabilityGreenTarget}%, Performance: &gt;={appsettings.PerformanceGreenTarget}%  </p>
                <p className='AddComment'>Click on cell to comment</p>
                <div className="AddComment">
                </div>
                <ReactTable
                    data={this.state.Metric}
                    columns={columns}
                    minRows={0}
                    maxRows={500}
                    defaultPageSize={100}
                    showPagination={true}
                    sortable={true}
                    filterable={true}
                    loading={this.state.loading}
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value}
                    style={{
                        borderStyle: 'solid',
                        borderWidth: "1px",
                        overflow: "hidden",
                    }}
                    className="-striped "
                    getTdProps={(state, rowInfo, column, instance) => {
                        const accessor = column ? (column.id || column.accessor) : null;
                        const isMetric = accessor && accessor.indexOf('data') === 0;
                        let severity = null;
                        if (isMetric && rowInfo && rowInfo.row) {
                            severity = getMetricSeverity(this.state.metricType.value, rowInfo.row[accessor]);
                        }
                        const clickable = !!(isMetric && (severity === 'orange' || severity === 'red'));
                        return {
                            title: clickable ? 'Click to view the URL failures causing this dip' : undefined,
                            style: {
                                borderColor: "#f7f7f7",
                                textAlign: 'center',
                                fontSize: '12px',
                                padding: '1px',
                                borderWidth: '1px',
                                wordWrap: 'break-word',
                                whiteSpace: 'pre-wrap',
                                background: rowInfo && rowInfo.index === this.state.selected ? '#96B1C7' : '',
                                cursor: clickable ? 'pointer' : 'default',
                                textDecoration: clickable ? 'underline' : 'none'
                            },
                            onClick: (e) => {
                                if (clickable && rowInfo && rowInfo.original) {
                                    this.onMetricCellClick(rowInfo.original, accessor, severity);
                                    return;
                                }
                                var colIndex = -1;
                                for (var j = 0; j < 6; j++) {
                                    if (selectedMonths[j] === column.Header)
                                        colIndex = j + 1;
                                }
                                this.setState({
                                    ComponentName: this.state.Metric[rowInfo.index].Component,
                                    Service: this.state.Metric[rowInfo.index].Service,
                                    DSMService: this.state.Metric[rowInfo.index].DSMService,
                                    SelectedMonthandYear: column.Header,
                                })
                                this.openModal(rowInfo.index, colIndex - 1);
                            }
                        };
                    }}
                    getTheadThProps={() => {
                        return {
                            style: {
                                background: "#f7f7f7",
                                borderColor: "#f7f7f7",
                                color: 'black',
                                textAlign: 'left',
                                fontSize: '14px',
                                height: '30px',
                                fontWeight: 'bold'
                            }
                        };
                    }}
                />

                <Modal
                    isOpen={this.state.modalIsOpen}
                    onRequestClose={this.closeModal}
                    style={customStyles}
                    ariaHideApp={false}
                    contentLabel="Example Modal"
                >
                    <h2 className="header">Add Comment</h2>
                    <input className="CommentTextInput" type="text" value={this.state.ComponentName} />
                    <input className="CommentTextInput" type="text" value={this.state.metricType.label} />
                    <div style={{ display: 'inline-flex', marginLeft: '15px', marginTop: '5px', width: '100%' }}>
                        <div style={{ marginTop: '5px', marginRight: '2%' }}>Start:</div><DateTime closeOnSelect={true} onBlur={this.updateFromDate.bind(this)} utc={true} defaultValue={this.today} />
                        <div style={{ marginTop: '5px', marginRight: '2%' }}>End:</div><DateTime closeOnSelect={true} onBlur={this.updateToDate.bind(this)} utc={true} defaultValue={this.today} />
                    </div>
                    <textarea className="CommentTextInput" ref="InputComment" type="text" placeholder="Type Comment Here" />
                    <button className="CommentSubmit" onClick={this.submitComment.bind(this)}>Submit</button>
                </Modal>
                <TelemetryDetailModal
                    isOpen={this.state.detailModalOpen}
                    onRequestClose={this.closeDetailModal}
                    severity={this.state.detailSeverity}
                    appname={this.state.detailAppname}
                    component={this.state.detailComponent}
                    service={this.state.detailService}
                    dsmService={this.state.detailDSMService}
                    metricType={this.state.detailMetricType}
                    metricValue={this.state.detailMetricValue}
                    environment={this.state.environment.value}
                    loading={this.state.detailLoading}
                    error={this.state.detailError}
                    details={this.state.detailData}
                    timeRange={this.state.detailTimeRange}
                />
            </div>
        );
    }
}
